var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemovePlasticWrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10389_60212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6949 36.2886L14.9032 32.2918C9.82968 34.5663 7.18538 37.6148 6.1786 42.1648C5.0161 36.8339 5.66854 30.7112 12.326 26.5431L10.5833 22.6558L20.935 26.1904L16.6949 36.2886Z",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5486 5.37139C16.2858 4.71453 16.7696 4 17.477 4H39.523C40.2304 4 40.7142 4.71453 40.4514 5.37139L39 9H18L16.5486 5.37139ZM18 13H39L42 20L38.625 18.6L35.25 20L31.875 18.6L28.5 20L25.125 18.6L21.75 20L18.375 18.6L15 20L18 13ZM39 10H18V12H39V10Z",
    fill: "#003E6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10389_60212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePlasticWrap);
export default __webpack_public_path__ + "static/media/remove_plastic_wrap.9b44a62c8adeea4056a23e87f60e2b93.svg";
export { ForwardRef as ReactComponent };